import {createRouter, createWebHistory} from "vue-router";

import Dashboard from "@/views/dashboard/dashboard.vue";
import Workers from "@/views/workers/workers.vue";
import Wallet from "@/views/wallet/wallet.vue";
import Rating from "@/views/rating/rating.vue";
import Settings from "@/views/settings/settings.vue";
import Login from "@/views/login/login.vue";
import Registration from "@/views/registration/registration.vue";
import Referral from "@/views/referral/referral.vue"
import RestorePassword from "@/views/restore-password/restore-password.vue";
import Documents from "@/views/documents/documents.vue";
import VerifyEmail from "@/views/verify-email/verify-email.vue";

import {getCookie} from "@/utils/functions";

const BACKGROUNDS = {
    default: "#ECF6FC",
    main: "#36a1ea",
};

const routes = [
    {
        path: "/",
        name: "dashboard",
        component: Dashboard,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/workers",
        name: "workers",
        component: Workers,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/wallet",
        name: "wallet",
        component: Wallet,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/services",
        name: "services",
        component: Rating,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/settings",
        name: "settings",
        component: Settings,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            layout: "authorization",
            background: BACKGROUNDS.main,
        },
    },
    {
        path: "/registration",
        name: "registration",
        component: Registration,
        meta: {
            layout: "authorization",
            background: BACKGROUNDS.main,
        },
    },
    {
        path: "/restore-password",
        name: "restore-password",
        component: RestorePassword,
        meta: {
            layout: "authorization",
            background: BACKGROUNDS.main,
        },
    },
    {
        path: "/referral",
        name: "referral",
        component: Referral,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/documents",
        name: "documents",
        component: Documents,
        meta: {
            layout: "default",
            auth: true,
            background: BACKGROUNDS.default,
        },
    },
    {
        path: "/verify-email",
        name: "verify-email",
        component: VerifyEmail,
        meta: {
            layout: "authorization",
            background: BACKGROUNDS.main,
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.auth)) {
        if (!getLogged()) {
            next({
                path: "/login",
            });
        } else {
            next();
        }
    } else if (
        (to.name === "login" || to.name === "registration") &&
        getLogged()
    ) {
        next({
            path: "/",
        });
    } else {
        next();
    }
});

function getLogged() {
    // accessToken/refreshToken — httpOnly, из JS недоступны (и refreshToken к тому же
    // ограничен path=/api/v1/auth). Факт логина проверяем по немаркерной куке "loggedIn",
    // которую сервер ставит/чистит вместе с ними (см. AuthController.setTokenCookies).
    return !!getCookie("loggedIn");
}

export default router;
